/**
 * Created by Jerker Nord on 2018-11-30.
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ThorReelSymbol} from "./ThorReelSymbol";
import {ThorGameConfig} from "../ThorGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TimelineLite} from "gsap";

export class StickyWild extends PIXI.Container {

    private static SPINE_ASSET_NAME:string = "chainRemove";
    private static WILD_CHAIN_REMOVE_ANIMATION_NAME:string = "WildChainRemove";

    private _originalSymbolName:string;
    private _originalReelPosition:PIXI.Point;
    private _wildSymbol:StateReelSymbol;
    private _wildChains:PIXI.Sprite;
    private _removeChainsSpine:PIXI.spine.Spine;
    private _removeChainsAnimation:SpineTween;
    private _removeChainsTL:TimelineLite;

    constructor(originalSymbolName:string, originalReelPosition:PIXI.Point) {
        super();
        this._originalSymbolName = originalSymbolName;
        this._originalReelPosition = originalReelPosition;
        this._wildSymbol = new ThorReelSymbol("W", 0);
        this._wildSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.sticky});
        this.addChild(this._wildSymbol);
        this._wildChains = new PIXI.Sprite(GameResources.getTextures("W_chains")[0]);
        this._wildChains.anchor.set(0.5, 0.5);
        this._wildChains.position.set(1, 3);
        this.addChild(this._wildChains);
        this._removeChainsSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(StickyWild.SPINE_ASSET_NAME));
        this._removeChainsSpine.alpha = 0;
        this._removeChainsAnimation = new SpineTween(this._removeChainsSpine, 0, StickyWild.WILD_CHAIN_REMOVE_ANIMATION_NAME, 0);
        this._removeChainsAnimation.kill();
        this.addChild(this._removeChainsSpine);
    }

    public getRemoveChainsTL():TimelineLite {
        if(this._removeChainsTL && this._removeChainsTL.isActive()) {
            this._removeChainsTL.pause();
            this._removeChainsTL.kill();
        }
        this._removeChainsTL = new TimelineLite({});
        this._removeChainsTL.add(() => this._removeChainsSpine.alpha = 1);
        this._removeChainsTL.add(() => this._wildSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.normal}));
        this._removeChainsTL.add(() => this._wildChains.visible = false);
        this._removeChainsTL.add(this._removeChainsAnimation.restart());
        this._removeChainsTL.add(() => this._removeChainsSpine.alpha = 0);
        return this._removeChainsTL;
    }

    get originalSymbolName():string {
        return this._originalSymbolName;
    }

    set originalSymbolName(value:string) {
        this._originalSymbolName = value;
    }

    get originalReelPosition():PIXI.Point {
        return this._originalReelPosition;
    }
}